import { render, staticRenderFns } from "./RelatorioTestsFinalPanel.vue?vue&type=template&id=730554cc&scoped=true&"
import script from "./RelatorioTestsFinalPanel.vue?vue&type=script&lang=js&"
export * from "./RelatorioTestsFinalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730554cc",
  null
  
)

export default component.exports